import { render, staticRenderFns } from "./AnomaliesList.vue?vue&type=template&id=84cceb32"
import script from "./AnomaliesList.vue?vue&type=script&lang=js"
export * from "./AnomaliesList.vue?vue&type=script&lang=js"
import style0 from "./AnomaliesList.vue?vue&type=style&index=0&id=84cceb32&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports